import get from 'lodash/get';

import {
  CLEAR_SERVICE_REQUEST,
  GET_ALL_SR_SUCCESS,
  GET_SERVICE_REQUESTS_IDS_SUCCESS,
  GET_SERVICE_REQUEST_STATUSES_SUCCESS,
  GET_SERVICE_REQUEST_SUCCESS,
  SERVICE_REQUESTS_COUNTS_SUCCESS,
  SERVICE_REQUESTS_SUCCESS,
  SERVICE_REQUESTS_UNIT_SUCCESS,
  SERVICE_REQUEST_COMMENTS_REQUESTED,
} from '../actionConstants';

const defaultState = {
  openSr: [],
  serviceRequestsIds: [],
};
export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_ALL_SR_SUCCESS: {
      return {
        ...state,
        allServiceRequests: get(action, 'res.data', []),
      };
    }
    case SERVICE_REQUESTS_SUCCESS: {
      const data = get(action, 'res.data', {});
      const status = get(action, 'queryParams.status', null);
      const serviceRequestsCounts = { ...state.serviceRequestsCounts };
      if (status) {
        serviceRequestsCounts[status] = data.count;
      }
      return {
        ...state,
        ...data,
        serviceRequestsCounts,
      };
    }
    case GET_SERVICE_REQUEST_SUCCESS: {
      const data = get(action, 'res.data', {});
      return {
        ...state,
        srData: { ...data },
      };
    }
    case SERVICE_REQUESTS_UNIT_SUCCESS: {
      const data = get(action, 'res.data', []);
      return {
        ...state,
        openSr: [...data],
      };
    }
    case GET_SERVICE_REQUESTS_IDS_SUCCESS: {
      const serviceRequestsIds = action?.res?.data?.sort((a, b) => a - b) || [];
      return {
        ...state,
        serviceRequestsIds,
      };
    }
    case CLEAR_SERVICE_REQUEST:
      return {
        ...state,
        srData: null,
        comments: [],
      };
    case SERVICE_REQUEST_COMMENTS_REQUESTED: {
      const data = get(action, 'payload.data', {});
      const comments =
        get(action, 'payload.data.results') ||
        get(action, 'payload.data') ||
        [];
      return {
        ...state,
        comments: { ...data, results: comments.reverse() },
      };
    }
    case SERVICE_REQUESTS_COUNTS_SUCCESS: {
      const data = action.option
        ? {
            ...state,
            serviceRequestsCounts: {
              ...state.serviceRequestsCounts,
              [action.option]: action.res && action.res.data[action.option],
            },
          }
        : {
            ...state,
            serviceRequestsCounts: action.res && action.res.data,
          };
      return data;
    }
    case GET_SERVICE_REQUEST_STATUSES_SUCCESS: {
      const data = get(action, 'res.data', {});
      return {
        ...state,
        srStatuses: { ...data },
      };
    }
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
